var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109px",
    height: "100px",
    viewBox: "0 0 109 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "envelope-pending@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,37.8151261 L51.8109091,75.5029284 L104,37.8151261 L104,95 C104,97.7614237 101.761424,100 99,100 L5,100 C2.23857625,100 3.38176876e-16,97.7614237 0,95 L0,37.8151261 L0,37.8151261 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property-transfer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.-property-detail---pending-property",
    transform: "translate(-459.000000, -270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(281.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope-pending",
    transform: "translate(178.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fill: "#9DA9B6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "0 37.8901561 52 0 104 37.8901561 104 82.2216387 47.2727273 84.8739496"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.7642276,9.24369748 L91.3902439,9.24369748 C94.1516677,9.24369748 96.3902439,11.4822737 96.3902439,14.2436975 L96.3902439,79.8319328 L96.3902439,79.8319328 L6.76422764,79.8319328 L6.76422764,14.2436975 C6.76422764,11.4822737 9.00280389,9.24369748 11.7642276,9.24369748 Z",
    id: "Rectangle",
    fill: "#F3F6F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D8E2",
    x: 41.4308943,
    y: 43.697479,
    width: 20.2926829,
    height: 1.68067227
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D0D8E2",
    x: 29.5934959,
    y: 47.0588235,
    width: 43.1219512,
    height: 1.68067227
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E1E7ED",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,28 C102.952931,28 109,21.9529294 109,14.5 C109,7.04706959 102.952931,1 95.5,1 C88.0470688,1 82,7.04706959 82,14.5 C82,21.9529294 88.0470688,28 95.5,28 Z M94.65625,6.99831627 C94.65625,6.48120223 95.0595147,6.0625 95.5547911,6.0625 C96.0513077,6.0625 96.4533323,6.48249372 96.4533323,6.99831627 L96.4533323,14.0685981 L100.205107,17.0072627 C100.608372,17.3301361 100.670127,17.9115665 100.391599,18.3315602 C100.205107,18.5901108 99.9580767,18.71875 99.6783211,18.71875 C99.4918298,18.71875 99.3065538,18.6544272 99.1515474,18.5245223 L95.028067,15.2957882 C94.8112998,15.1343515 94.65625,14.8442821 94.65625,14.5529211 L94.65625,6.99831627 Z",
    id: "Fill-1",
    fill: "#F26558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9762782,30.648549 C53.3424896,31.0147539 53.3424896,31.608029 52.9762782,31.9742089 C52.6100668,32.3404137 52.0167812,32.3404137 51.6505948,31.9742089 L43.8749941,24.2006208 L43.8749941,28.1873503 C43.8749941,28.7049145 43.4550705,29.1248307 42.9374971,29.1248307 C42.4199237,29.1248307 42,28.7049145 42,28.1873503 L42,21.9374805 C42,21.4199163 42.4199237,21 42.9374971,21 L49.1874775,21 C49.7050509,21 50.1249746,21.4199163 50.1249746,21.9374805 C50.1249746,22.4550447 49.7050509,22.8749609 49.1874775,22.8749609 L45.2006775,22.8749609 L52.9762782,30.648549 Z M61.0625029,27.8751693 C60.5449295,27.8751693 60.1250059,28.2950855 60.1250059,28.8126497 L60.1250059,32.7993792 L52.3512802,25.0239162 C51.9850688,24.6577113 51.3917832,24.6577113 51.0255968,25.0239162 C50.6593854,25.390121 50.6593854,25.9833962 51.0255968,26.3495761 L58.7993225,34.1250391 L54.8125225,34.1250391 C54.2949491,34.1250391 53.8750254,34.5449553 53.8750254,35.0625195 C53.8750254,35.5800837 54.2949491,36 54.8125225,36 L61.0625029,36 C61.5800763,36 62,35.5800837 62,35.0625195 L62,28.8126497 C62,28.2950855 61.5800763,27.8751693 61.0625029,27.8751693 Z",
    id: "Fill-1",
    fill: "#468F2D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopePending);
export default __webpack_public_path__ + "static/media/envelope-pending.726f1d45927a0d342bed6e757feb5523.svg";
export { ForwardRef as ReactComponent };